import { z } from "zod";
import { centsSchema, idSchema, isoDateSchema, leftoverModeSchema, optionalText, positiveCentsSchema, requiredText, splitModeSchema, } from "./common.js";
const weightSchema = z
    .number()
    .min(0, { message: "O peso não pode ser negativo." })
    .max(1000, { message: "Peso alto demais." });
export const expenseShareSchema = z.object({
    personId: idSchema,
    weight: weightSchema.optional(),
    exactAmountCents: centsSchema.min(0).nullish(),
    /** O helper: quem banca a parte dessa pessoa. */
    coveredByPersonId: idSchema.nullish(),
});
export const expenseItemSchema = z.object({
    name: requiredText(80, "item"),
    amountCents: positiveCentsSchema,
    shares: z
        .array(z.object({ personId: idSchema, weight: weightSchema.optional() }))
        .min(1, { message: "Marque quem consumiu o item." }),
});
export const expensePayerSchema = z.object({
    personId: idSchema,
    amountCents: positiveCentsSchema,
});
function uniqueBy(list, key) {
    return new Set(list.map(key)).size === list.length;
}
export const createExpenseSchema = z
    .object({
    description: requiredText(120, "descrição"),
    notes: optionalText(500).nullable(),
    amountCents: positiveCentsSchema,
    occurredAt: isoDateSchema.optional(),
    splitMode: splitModeSchema.default("EQUAL"),
    leftoverMode: leftoverModeSchema.default("PROPORTIONAL"),
    payers: z.array(expensePayerSchema).min(1, { message: "Informe quem pagou a conta." }),
    shares: z.array(expenseShareSchema).min(1, { message: "Escolha entre quem dividir." }),
    items: z.array(expenseItemSchema).optional(),
})
    .superRefine((data, ctx) => {
    const paid = data.payers.reduce((acc, payer) => acc + payer.amountCents, 0);
    if (paid !== data.amountCents) {
        ctx.addIssue({
            code: z.ZodIssueCode.custom,
            path: ["payers"],
            message: "A soma do que cada um pagou precisa ser igual ao valor da despesa.",
        });
    }
    if (!uniqueBy(data.payers, (payer) => payer.personId)) {
        ctx.addIssue({
            code: z.ZodIssueCode.custom,
            path: ["payers"],
            message: "A mesma pessoa foi informada duas vezes como pagante.",
        });
    }
    if (!uniqueBy(data.shares, (share) => share.personId)) {
        ctx.addIssue({
            code: z.ZodIssueCode.custom,
            path: ["shares"],
            message: "A mesma pessoa foi incluída duas vezes na divisão.",
        });
    }
    if (data.splitMode === "ITEMS" && (data.items ?? []).length === 0) {
        ctx.addIssue({
            code: z.ZodIssueCode.custom,
            path: ["items"],
            message: "Adicione pelo menos um item.",
        });
    }
    if (data.splitMode === "EXACT") {
        const missing = data.shares.some((share) => share.exactAmountCents === undefined || share.exactAmountCents === null);
        if (missing) {
            ctx.addIssue({
                code: z.ZodIssueCode.custom,
                path: ["shares"],
                message: "Informe o valor exato de cada pessoa.",
            });
        }
    }
});
/** Editar uma despesa reescreve pagantes, partes e itens: e sempre um PUT. */
export const updateExpenseSchema = createExpenseSchema;
//# sourceMappingURL=expense.js.map